iScreenWizard.controller('ToolbarController', function ($scope, $state, $location, $timeout, $mdSidenav, $mdDialog, $log, Taal, Dictionary, userService, Menu) {

    $scope.userService = userService;
    $scope.menu = Menu;
    $scope.autoFocusContent = false;
    $scope.isHome = false;
    $scope.language = null;
    $scope.languages = [];

    $scope.logout = function () {

        //reset user data
        userService.logout();

    };

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    $scope.refresh = function() {
        $scope.isHome = $location.path() == '/home';
        Taal.all().then(function(languages) {
            $scope.languages = languages;
            languages.forEach(function(language) {
                if (language.id == locale_id) {
                    $scope.language = language;
                }
            });
        });
    };

    var toggleSidebar = buildDelayedToggler('left');
    $scope.toggleSidebar = toggleSidebar;

    /**
     * Supplies a function that will continue to operate until the
     * time is up.
     */
    function debounce(func, wait, context) {
        var timer;
        return function debounced() {
            var context = $scope,
                args = Array.prototype.slice.call(arguments);
            $timeout.cancel(timer);
            timer = $timeout(function() {
                timer = undefined;
                func.apply(context, args);
            }, wait || 10);
        };
    }
    /**
     * Build handler to open/close a SideNav; when animation finishes
     * report completion in console
     */
    function buildDelayedToggler(navID) {
        return debounce(function() {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav(navID)
                .toggle();
        }, 200);
    }

    $scope.isOpen = function(section) {
        return section.open;
    }
    $scope.toggleOpen = function(section) {
        section.open = !section.open;
    }

    $scope.updateLanguage = function() {
        Cookies.remove('locale');
        Cookies.set('locale', $scope.language.afkorting);
        Cookies.set('locale_id', $scope.language.id);
        location.reload();
    };

});